import React from "react";

/**
 * VehicleDetailEcoIcon
 *
 * Icon for eco/nature/leaf detail. Used in VehicleDetailsList or for emissions/umwelt.
 */
const VehicleDetailEcoIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    height={20}
    width={20}
    className={className}
  >
    <g id="leaf-protect--nature-environment-leaf-ecology-plant-plants-eco">
      <path
        id="Union"
        fill="#36b605"
        fillRule="evenodd"
        d="M12.346 0.216C9.659 0.326 6.265 1.036 3.764 3.537.829 6.473.223 10.891 2.291 13.993c-.747 1.648-1.22 3.388-1.22 5.153 0 .36.292.653.653.653.36 0 .653-.293.653-.653 0-1.347.318-2.701.85-4.023l.005.005c.972-2.368 2.651-4.572 4.386-6.419C10.332 5.82 13.316 3.665 14.429 2.923c.3-.2.706-.119.906.181.2.3.119.705-.181.906-1.064.71-3.96 2.802-6.582 5.594-1.81 1.927-3.429 4.124-4.272 6.385 1.503.99 3.31 1.356 5.107 1.137-.324-.802-.494-1.67-.494-2.553 0-.789.042-1.492.09-2.04.105-1.2.911-2.371 2.344-2.573.703-.1 1.729-.178 3.227-.178 1.232 0 2.144.053 2.82.127.42-1.378.597-2.762.647-3.997.055-1.353-.04-2.552-.149-3.413a13.6 13.6 0 0 0-.158-.781c-.023-.121-.042-.216-.056-.281a.653.653 0 0 0-.177-.293c-.13-.13-.26-.155-.39-.179-.242-.045-.59-.103-1.021-.158-.861-.109-2.06-.204-3.413-.149ZM10.303 12.648c.064-.72.511-1.294 1.226-1.395.626-.088 1.588-.165 3.045-.165s2.418.077 3.044.165c.715.101 1.162.675 1.225 1.395.045.517.085 1.181.085 1.925 0 1.966-1.038 3.806-2.786 4.706-.584.3-1.154.52-1.57.52-.415 0-.985-.22-1.569-.52-1.748-.9-2.786-2.74-2.786-4.706 0-.744.04-1.408.085-1.925Zm6.809.074c.301.199.384.604.185.905l-2.306 3.485a.653.653 0 0 1-1.128-.232l-1.614-1.858a.653.653 0 0 1 .065-.92c.273-.237.686-.208.923.064l1.05 1.21 1.832-2.768a.653.653 0 0 1 1.111.11Z"
        clipRule="evenodd"
        strokeWidth={1}
      />
    </g>
  </svg>
);

export default VehicleDetailEcoIcon;
